import React from 'react';
import Button from 'components/common/button/Button';
import PageTitle from 'components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'state/hooks';
import { selectMissedPaymentByPolicy } from 'state/selectors/vehicles';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { RoutePaths } from 'Constants/Common';
import { selectCurrency } from 'state/selectors/site';
import MissedPaymentInfo from './MissedPaymentInfo';
import { PaymentTypes } from '../singlePayment/PaymentPage';
import { buildPaymentPagePath } from 'helpers/routing';

const MissedPayment = () => {
    const params = useParams();
    const { t } = useTranslation();

    const navigate = useNavigate();

    const currency = useAppSelector(selectCurrency);
    const bankDetails = useAppSelector((s) => s.customer.bankDetail);
    const missedPayment = useAppSelector((s) =>
        selectMissedPaymentByPolicy(s, params.policyReference)
    );

    if (!missedPayment) return <Navigate to={RoutePaths.Home} replace />;

    const amountToPay = `${currency}${missedPayment.amount}`;

    const paymentPagePath = buildPaymentPagePath(
        PaymentTypes.MissedPayment,
        params.policyReference
    );

    return (
        <div className='page-content'>
            <PageTitle title={t('missed_payment.page_title')} />
            <div
                className='page-content-body m-auto p-3'
                style={{ maxWidth: '800px' }}>
                <MissedPaymentInfo
                    amount={amountToPay}
                    date={missedPayment.date}
                    bankDetails={bankDetails}
                />
                <div className='d-grid gap-2 mt-4'>
                    <Link
                        to={paymentPagePath}
                        className='btn btn-primary'
                        data-testid='pay-button'>
                        {t('pay_amount', { amount: amountToPay })}
                    </Link>
                    <Button
                        data-testid='back-button'
                        onClick={() => navigate(-1)}
                        text={t('back')}
                        className='btn btn-secondary'
                    />
                </div>
            </div>
        </div>
    );
};

export default MissedPayment;
